import { Viewer3D } from "./components/viewer-3d";
import "./index.css";

export function App() {
  return <Viewer3D />;
}

export default App;
